import { createContext } from "react";

import { gRPCStatus } from "api/grpc-status-codes";

export interface GrpcError extends Error {
  code: gRPCStatus;
}

type SnackbarContextType = {
  copyToClipboard: (text: string) => void;
  showError: (e: GrpcError) => void;
};

export const SnackbarContext = createContext({} as SnackbarContextType);
